import {
    Grid,
    Typography,
    Button,
    Divider,
    TextField,
    IconButton,
    Avatar,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import img1 from "../assets/dch logooo.png";
import FavoriteIcon from '@mui/icons-material/Favorite';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import React, { useEffect, useState } from "react";
import { getData, postData, serverURL } from "../../../Services/NodeServices";
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Cancel } from '@mui/icons-material';

export default function Kitchen() {
    const location = useLocation();
    const navigate = useNavigate();
    const menuId = location.state.menuId;

    const [fullData, setFullData] = useState([]);
    const [expandedData, setExpandedData] = useState([]);

    const [Name, setName] = useState("");
    const [Phone, setPhone] = useState("");
    const [Chief, setChief] = useState("");
    const [Table, setTable] = useState("Serve On Table");
    const [Number, setNumber] = useState("");

    const [ownerNumber, setOwnerNumber] = useState("")
    const [showOrder, setShowOrder] = useState(false);
    const [order, setOrder] = useState([]);


    const fetchRestaurantData = async () => {
        var formData = new FormData
        formData.append("menuId", menuId)
        const response = await postData('index/getRestaurantDetails', formData, true)

        if (response.status == true) {
            setOwnerNumber(response.data.number)
        }
    }

    useEffect(() => {
        fetchRestaurantData()
    }, []);

    const checkCart = () => {
        const cart = JSON.parse(window.localStorage.getItem("menucart"));

        if (cart && cart.length > 0) {
            setFullData(cart);
            const expanded = cart.reduce((acc, item) => {
                item.quantity.forEach((q) => {
                    if (q.count && q.count > 0) {
                        acc.push({
                            ...item,
                            quantity: q.count,
                            totalprice: parseFloat(q.rate) * q.count,
                            rate: parseFloat(q.rate),
                            type: q.title
                        });
                    }
                });
                return acc;
            }, []);

            setExpandedData(expanded);
        } else {
            navigate(`/menu/${menuId}`);
        }
    };

    useEffect(() => {
        checkCart();
    }, []);

    const totalPrice = expandedData.reduce((total, item) => total + item.totalprice, 0);

    const checkOrder = () => {
        let order1 = JSON.parse(window.localStorage.getItem("menuorder"));

        if (order1 != null && order1.length !== 0) {
            setOrder(order1);
            setShowOrder(true);
        }
    };

    useEffect(() => {
        checkOrder();
    }, []);

    const handleSubmit = async () => {
        if (Name.trim() !== "" && /^[6-9]\d{9}$/.test(Phone.trim())){
            const menuorderdata = new FormData();
            menuorderdata.append("menuId", menuId);
            menuorderdata.append("name", Name);
            menuorderdata.append("phone", Phone);
            menuorderdata.append("message", Chief);
            menuorderdata.append("table", Table);
            menuorderdata.append("Number", Number);
            menuorderdata.append("totalPrice", totalPrice);
            menuorderdata.append("dishes", JSON.stringify(expandedData));

            const response = await postData("index/menuorder", menuorderdata, true);

            const tax = (totalPrice * 5) / 100;
            const grandTotal = totalPrice + tax;

            const orderDetails = expandedData.map((item, index) => {
                return `${index + 1}. ${item.type} - ${item.name} × ${item.quantity}`;
            }).join("%0A");

            const customerMessage =
                `🧾 *Your Order Sent to Kitchen*%0A` +
                `👤 Name: ${Name}%0A` +
                `📞 Phone: ${Phone}%0A` +
                `🍽️ Table: ${Table}%0A` +
                `🍽️ Table Number: ${Number}%0A` +
                `📝 Message: ${Chief || "-"}%0A%0A` +
                `🍲 *Items Ordered:*%0A${orderDetails}%0A%0A` +
                `💰 *Subtotal:* ₹${totalPrice.toFixed(2)}%0A` +
                `📊 *SGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `📊 *CGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `💳 *Grand Total:* ₹${grandTotal.toFixed(2)}`;

            const ownerMessage =
                `🧾 *New Order Received*%0A` +
                `👤 Name: ${Name}%0A` +
                `📞 Phone: ${Phone}%0A` +
                `🍽️ Table: ${Table}%0A` +
                `🍽️ Table Number: ${Number}%0A` +
                `📝 Message: ${Chief || "-"}%0A%0A` +
                `🍲 *Items Ordered:*%0A${orderDetails}%0A%0A` +
                `💰 *Subtotal:* ₹${totalPrice.toFixed(2)}%0A` +
                `📊 *SGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `📊 *CGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `💳 *Grand Total:* ₹${grandTotal.toFixed(2)}`;

            if (response.status === true) {
                Swal.fire({ text: "Order Sent to kitchen", icon: "success", timer: 1000 });
                const apiUrl = `https://wa.soft7.in/api/send?number=91${Phone}&type=text&message=${customerMessage} &instance_id=68C3AB650346F&access_token=68c3ab2b76e40`;
                const apiUrl2 = `https://wa.soft7.in/api/send?number=91${ownerNumber}&type=text&message=${ownerMessage} &instance_id=68C3AB650346F&access_token=68c3ab2b76e40`;
                const response1 = await postData('otp/api', { url: apiUrl2 })
                const response2 = await postData('otp/api', { url: apiUrl })
                window.localStorage.setItem("menuorder", JSON.stringify(response.data));
                window.localStorage.removeItem("menucart");
                navigate('/menucheckout', { state: { menuId: menuId } });
            } else {
                Swal.fire({ text: "Failed to send", icon: "error", timer: 1000 });
            }
        } else {
            Swal.fire({ text: "Fill Valid Details" });
        }
    };

    const handleUpdate = async () => {
        const dishesData = [...JSON.parse(order.dishes), ...expandedData];
        if (Name.trim() !== "" && /^[6-9]\d{9}$/.test(Phone.trim())){
            const menuorderdata = new FormData();
            menuorderdata.append("_id", order._id);
            menuorderdata.append("name", Name);
            menuorderdata.append("phone", Phone);
            menuorderdata.append("message", Chief);
            menuorderdata.append("totalPrice", parseInt(order.totalPrice) + parseInt(totalPrice));
            menuorderdata.append("dishes", JSON.stringify(dishesData));

            const response = await postData("index/updatemenuorder", menuorderdata, true);
            const price = parseInt(order.totalPrice) + parseInt(totalPrice);
            const tax = (price * 5) / 100;
            const grandTotal = price + tax;

            const orderDetails = dishesData.map((item, index) => {
                return `${index + 1}. ${item.type} - ${item.name} × ${item.quantity}`;
            }).join("%0A");

            const customerMessage =
                `🧾 *Updated Order Details*%0A` +
                `*Order Id: ${order._id}*%0A` +
                `👤 Name: ${Name}%0A` +
                `📞 Phone: ${Phone}%0A` +
                `🍽️ Table: ${Table}%0A` +
                `🍽️ Table Number: ${order.Number}%0A` +
                `📝 Message: ${Chief || "-"}%0A%0A` +
                `🍲 *Items Ordered:*%0A${orderDetails}%0A%0A` +
                `💰 *Subtotal:* ₹${price.toFixed(2)}%0A` +
                `📊 *SGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `📊 *CGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `💳 *Grand Total:* ₹${grandTotal.toFixed(2)}`;

            const ownerMessage =
                `🧾 *Updated Order Details*%0A` +
                `*Order Id: ${order._id}*%0A` +
                `👤 Name: ${Name}%0A` +
                `📞 Phone: ${Phone}%0A` +
                `🍽️ Table: ${Table}%0A` +
                `🍽️ Table Number: ${order.Number}%0A` +
                `📝 Message: ${Chief || "-"}%0A%0A` +
                `🍲 *Items Ordered:*%0A${orderDetails}%0A%0A` +
                `💰 *Subtotal:* ₹${price.toFixed(2)}%0A` +
                `📊 *SGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `📊 *CGST (2.5%):* ₹${(tax / 2).toFixed(2)}%0A` +
                `💳 *Grand Total:* ₹${grandTotal.toFixed(2)}`;

            if (response.status === true) {
                Swal.fire({ text: "Order Updated to kitchen", icon: "success", timer: 1000 });
                const apiUrl = `https://wa.soft7.in/api/send?number=91${Phone}&type=text&message=${customerMessage} &instance_id=68C3AB650346F&access_token=68c3ab2b76e40`;
                const apiUrl2 = `https://wa.soft7.in/api/send?number=91${ownerNumber}&type=text&message=${ownerMessage} &instance_id=68C3AB650346F&access_token=68c3ab2b76e40`;
                const response1 = await postData('otp/api', { url: apiUrl2 })
                const response2 = await postData('otp/api', { url: apiUrl })
                window.localStorage.setItem("menuorder", JSON.stringify(response.data));
                window.localStorage.removeItem("menucart");
                navigate('/menucheckout', { state: { menuId: menuId } });
            } else {
                Swal.fire({ text: "Failed to send", icon: "error", timer: 1000 });
            }
        } else {
            Swal.fire({ text: "Fill Valid Details" });
        }
    };

    const handleChange = (event) => {
        setTable(event.target.value);
    };

    const handleDelete = (index) => {
        const updatedExpanded = [...expandedData];
        const itemToRemove = updatedExpanded[index];

        const updatedFullData = fullData.map((fdItem) => {
            if (fdItem._id === itemToRemove._id) {
                const updatedQuantities = fdItem.quantity.map((q) =>
                    q.title === itemToRemove.type ? { ...q, count: 0 } : q
                );
                return { ...fdItem, quantity: updatedQuantities };
            }
            return fdItem;
        });

        updatedExpanded.splice(index, 1);
        setExpandedData(updatedExpanded);
        setFullData(updatedFullData);
        window.localStorage.setItem("menucart", JSON.stringify(updatedFullData));
    };

    return (
        <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Grid container spacing={2} sx={{ width: 450 }}>
                <Grid item xs={6}>
                    <img src={img1} alt="Masala Grill" width={120} />
                </Grid>

                <Grid item xs={6}>
                    <Button variant="outlined" sx={{ bgcolor: 'yellow', mt: 2 }}><WhatsAppIcon />Live support</Button>
                </Grid>

                <Divider sx={{ backgroundColor: 'black', height: '1px', width: '100%', mt: 1 }} />

                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Typography><FavoriteIcon sx={{ width: 20 }} /></Typography>
                    <Typography sx={{ fontSize: 20, fontFamily: 'poppins', ml: 1 }}>Thank You!</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography sx={{ textAlign: 'left' }}>Please check your cart and you can pay after adding your</Typography>
                    <Typography sx={{ textAlign: 'left' }}>shipping details</Typography>
                </Grid>

                <Grid item xs={5}><Typography>Dish Name</Typography></Grid>
                <Grid item xs={3}><Typography>Dish Price</Typography></Grid>
                <Grid item xs={3}><Typography>Total Price</Typography></Grid>
                <Grid item xs={1}></Grid>

                {expandedData.map((item, index) => (
                    <React.Fragment key={index}>
                        <Grid item xs={1}><Typography>{index + 1}</Typography></Grid>
                        <Grid item xs={5}><Typography>{item.type} - {item.name} × {item.quantity}</Typography></Grid>
                        <Grid item xs={2}><Typography>Rs:{item.rate}</Typography></Grid>
                        <Grid item xs={3}><Typography>Rs:{item.totalprice}</Typography></Grid>
                        <Grid item xs={1}><IconButton sx={{ mt: -1 }} onClick={() => handleDelete(index)}><Cancel /></IconButton></Grid>
                    </React.Fragment>
                ))}

                <Grid item xs={12}>
                    <Typography sx={{ mt: 5 }}>Total: ₹ {totalPrice}</Typography>
                    <Typography>SGST: ₹ {(totalPrice * 2.5) / 100}</Typography>
                    <Typography>CGST: ₹ {(totalPrice * 2.5) / 100}</Typography>
                    <Typography>Grand Total: ₹ {((totalPrice * 5) / 100) + totalPrice}</Typography>
                </Grid>

                {showOrder ? (
                    <>
                        <Grid item xs={6}><TextField onChange={(e) => setName(e.target.value)} value={Name} label="Name" variant="outlined" /></Grid>
                        <Grid item xs={6}><TextField onChange={(e) => setPhone(e.target.value)} value={Phone} label="Whatsapp Phone*" variant="outlined" /></Grid>
                        <Grid item xs={12}><TextField onChange={(e) => setChief(e.target.value)} value={Chief} fullWidth label="Any message for the chef?" /></Grid>
                        <Grid item xs={12}><Button sx={{ bgcolor: 'black' }} onClick={handleUpdate} fullWidth variant="contained" disableElevation><Typography sx={{ color: 'yellow' }}>Update the order</Typography></Button></Grid>
                    </>
                ) : (
                    <>
                        <Grid item xs={6}><TextField onChange={(e) => setName(e.target.value)} value={Name} label="Name" variant="outlined" /></Grid>
                        <Grid item xs={6}><TextField onChange={(e) => setPhone(e.target.value)} value={Phone} label="Whatsapp Phone*" variant="outlined" /></Grid>
                        <Grid item xs={12}><TextField onChange={(e) => setChief(e.target.value)} value={Chief} fullWidth label="Any message for the chef?" /></Grid>
                        <Grid item xs={12}><FormControl fullWidth><Select value={Table} onChange={handleChange}><MenuItem value="Serve On Table">Serve On Table</MenuItem><MenuItem value="Home Delivery">Home Delivery</MenuItem></Select></FormControl></Grid>
                        <Grid item xs={12}><TextField onChange={(e) => setNumber(e.target.value)} value={Number} fullWidth label="Table Number" /></Grid>
                        <Grid item xs={12}><Button sx={{ bgcolor: 'black' }} onClick={handleSubmit} fullWidth variant="contained" disableElevation><Typography sx={{ color: 'yellow' }}>Send to Kitchen</Typography></Button></Grid>
                    </>
                )}
            </Grid>
        </Grid>
    );
}
